import { Loader } from "monday-ui-react-core";
import React from "react";
import styled from "styled-components";

const LoaderWrapper = styled.div`
  width: auto;
  height: auto;
  margin-right: 2px;
`;

export const DropdownLoader: React.FC = () => {
  return (
    <LoaderWrapper>
      <Loader size={Loader.sizes.XS} color={Loader.colors["var(--secondary-text-color)"]}></Loader>
    </LoaderWrapper>
  );
};
